import { FeatureFlagType } from '../types';

export enum Scope {
    Retrieve = 'Retrieve',
    Upload = 'Upload',
    Monitor = 'Monitor',
    Execute = 'Execute',
}

export const AccessTokenScope: Record<
    Scope,
    {
        name: string;
        description: string;
        features: FeatureFlagType[];
    }
> = {
    [Scope.Retrieve]: {
        name: Scope.Retrieve.toLowerCase(),
        description: 'Generate a token for retrieving the data selected from the iAMP Platform',
        features: ['retrieve.api', 'retrieve.files', 'retrieve.stream'],
    },
    [Scope.Upload]: {
        name: Scope.Upload.toLowerCase(),
        description: 'Generate a token for uploading your data to the iAMP Platform',
        features: ['harvester.platform-api'],
    },
    [Scope.Monitor]: {
        name: Scope.Monitor.toLowerCase(),
        description: 'Generate a token for monitoring the execution status of a pipeline',
        features: ['harvester.platform-api'],
    },
    [Scope.Execute]: {
        name: Scope.Execute.toLowerCase(),
        description: 'Generate a token for executing an analytics pipeline',
        features: ['analytics'],
    },
};

export const tokenScopes = Object.values(AccessTokenScope).filter(
    (value) => value.name !== Scope.Execute.toLowerCase(),
);
